import { Link } from "react-router-dom";
import { Instagram } from "lucide-react";
import { LogoMark } from "./Logo";
import { NewsletterForm } from "./NewsletterForm";

const COLS = [
  {
    title: "Shop",
    links: [
      { to: "/shop", label: "Shop All" },
      { to: "/drops", label: "New Drops" },
      { to: "/collections", label: "Collections" },
      { to: "/run-club", label: "Run Club" },
    ],
  },
  {
    title: "Support",
    links: [
      { to: "/contact", label: "Contact" },
      { to: "/faq", label: "FAQ" },
      { to: "/shipping-returns", label: "Shipping & Returns" },
      { to: "/track-order", label: "Track Order" },
    ],
  },
  {
    title: "Company",
    links: [
      { to: "/about", label: "About TRAILNONE" },
      { to: "/account", label: "Account" },
      { to: "/privacy", label: "Privacy Policy" },
      { to: "/terms", label: "Terms of Service" },
    ],
  },
];

export const Footer = () => (
  <footer className="border-t border-border" data-testid="footer">
    <div className="grid gap-12 px-5 py-16 sm:px-10 lg:grid-cols-[1.4fr_1fr_1fr_1fr] lg:px-16 lg:py-20">
      <div>
        <div className="flex items-center gap-2.5">
          <LogoMark />
          <span className="font-display text-lg font-bold uppercase tracking-[0.18em]">
            Trailnone
          </span>
        </div>
        <p className="mt-5 max-w-xs text-sm leading-relaxed text-muted-foreground">
          Premium streetwear for the ones who move different. Follow your own
          path. Lead with authenticity.
        </p>
        <div className="mt-6 max-w-sm">
          <p className="mb-3 font-mono text-[11px] uppercase tracking-[0.22em] text-muted-foreground">
            First access to drops
          </p>
          <NewsletterForm source="footer" compact />
        </div>
        <div className="mt-8 flex gap-4">
          <a href="https://instagram.com/trailnone" target="_blank" rel="noreferrer" data-testid="social-instagram" aria-label="Instagram @trailnone" className="border border-border p-2.5 text-muted-foreground transition-colors hover:border-signal hover:text-signal">
            <Instagram className="h-4 w-4" />
          </a>
          <a href="https://tiktok.com/@trailnone" target="_blank" rel="noreferrer" data-testid="social-tiktok" aria-label="TikTok @trailnone" className="flex items-center justify-center border border-border p-2.5 text-muted-foreground transition-colors hover:border-signal hover:text-signal">
            <span className="font-mono text-[10px] font-bold leading-none">TT</span>
          </a>
        </div>
      </div>
      {COLS.map((col) => (
        <div key={col.title}>
          <h4 className="font-mono text-[11px] uppercase tracking-[0.22em] text-muted-foreground">
            {col.title}
          </h4>
          <ul className="mt-5 space-y-3">
            {col.links.map((l) => (
              <li key={l.to}>
                <Link
                  to={l.to}
                  data-testid={`footer-${l.label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                  className="text-sm text-foreground/80 transition-colors hover:text-signal"
                >
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      ))}
    </div>
    <div className="flex flex-col items-start justify-between gap-3 border-t border-border px-5 py-6 font-mono text-[11px] uppercase tracking-[0.2em] text-muted-foreground sm:flex-row sm:items-center sm:px-10 lg:px-16">
      <span>© 2026 TRAILNONE. All rights reserved.</span>
      <span className="text-signal">Follow your own path.</span>
    </div>
  </footer>
);
